const emailValidator = (value) => {
  const atIndex = value?.indexOf('@');
  const dotIndex = value?.lastIndexOf('.');
  return atIndex > 0 && dotIndex > atIndex + 1;
};

export default emailValidator;
